import { io, type Socket } from 'socket.io-client';

import { env } from '@/shared/config/env.js';

/** Socket autenticado (BR-CONV-04) — mesmo handshake/protocolo do mobile. */
export function createConversationSocket(accessToken: string): Socket {
  const baseUrl = env.VITE_API_BASE_URL.length > 0 ? env.VITE_API_BASE_URL : window.location.origin;
  return io(baseUrl, {
    transports: ['websocket'],
    auth: { token: accessToken },
    reconnection: true,
    reconnectionDelay: 500,
  });
}

/** Espelho de `apps/api/.../conversation.events.ts` — nomes compartilhados com o mobile. */
export const STAFF_CHAT_EVENTS = {
  join: 'conversation:join',
  send: 'message:send',
  new: 'message:new',
  history: 'message:history',
  opened: 'conversation:opened',
  listUpdate: 'conversation:list-update',
  read: 'conversation:read',
  ack: 'conversation:ack',
  error: 'conversation:error',
  /** BR-CONV-23 */
  edit: 'message:edit',
  edited: 'message:edited',
  delete: 'message:delete',
  deleted: 'message:deleted',
} as const;

export interface StaffChatMessageAuthor {
  readonly kind: 'consumer' | 'staff';
  readonly principalId: string;
}

export interface StaffChatMessage {
  readonly id: string;
  readonly conversationId: string;
  readonly author: StaffChatMessageAuthor;
  readonly kind: 'text' | 'image' | 'video' | 'audio';
  readonly text: string | null;
  readonly sentAt: string;
  /** BR-CONV-23 */
  readonly editedAt?: string | null;
  readonly deletedAt?: string | null;
  readonly imageUrl?: string;
  readonly videoUrl?: string;
  readonly audioUrl?: string;
  readonly durationSeconds?: number;
}

export interface StaffChatListUpdatePayload {
  readonly conversationId: string;
  readonly tenantId: string;
  readonly kind: 'text' | 'image' | 'video' | 'audio';
  readonly text: string | null;
  readonly sentAt: string;
  readonly authorKind: 'consumer' | 'staff';
}

export interface StaffChatErrorPayload {
  readonly code?: string;
  readonly message?: string;
}
